module.exports = __webpack_public_path__ + "img/1515040185.7aab1982.jpg";